module.exports = __webpack_public_path__ + "img/secure-payment-line.295c3ee2.svg";